export default __webpack_public_path__ + "static/media/instagram.44f0fd19.svg";